import Ajax from "Utils/ajax";
export const getUserRoles = (data) => Ajax.post('admin/getAllRolesForDropDown',data);
export const getAllMenuByRoleId = (data) => Ajax.post('admin/getAllMenuByRoleId',data);
export const addUpdateRoleMenu = (data) => Ajax.post('admin/addUpdateRoleMenu',data);
export const getAllocatedMenuByRole = (data) => Ajax.post('admin/getAllocatedMenuByRole',data);